export { default } from './UnsplashCreditBadge'



// WEBPACK FOOTER //
// ./src/components/UnsplashCreditBadge/index.ts